/* Qasr'e Mohtaram gallery script — source hosted in Content → Files (qasr-gallery.js). */
(function(){ var s = document.createElement('script'); s.src = 'https://cdn.shopify.com/s/files/1/2151/6835/files/qasr-gallery.js?v=1791211709'; s.defer = true; document.head.appendChild(s); })();
